import React from 'react';

import { AppProvider } from './provider';
import { AppRouter } from './router';

import { init as initPersistedState } from '@/state/persisted';

export const App = () => {
  const [isReady, setReady] = React.useState(false);

  React.useEffect(() => {
    initPersistedState().then(() => {
      setReady(true);
    });
  }, []);

  if (!isReady) {
    return null;
  }
  return (
    <AppProvider>
      <AppRouter />
    </AppProvider>
  );
};
